import React from 'react';
import Modal from 'react-modal';

const BaseModal = (props) => {
  const {
    isOpen,
    onRequestClose,
    shouldCloseOnOverlayClick,
    styles,
    className,
    children,
  } = props;

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: '99999',
      overflowY: 'auto',
      display: 'flex',
      justifyContent: 'center',
    },
    content: {
      position: 'static',
      alignSelf: 'center',
      margin: 'auto',
      ...styles,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      className={className}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      appElement={document.getElementById('root')}
    >
      {children}
    </Modal>
  );
};

export default BaseModal;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/BaseModal/BaseModal.js